import Modal from 'bootstrap/js/src/modal';

export const bootstrapTooltips = () => {
  $(() => {
    const tooltipElements = $('[data-bs-toggle="tooltip"], [data-bs-tooltip]');

    if (!tooltipElements.length) return;

    Promise.all([
      import(/* webpackChunkName: "bootstrap-tooltip" */ 'bootstrap/js/src/tooltip'),
      import(/* webpackChunkName: "bootstrap-tooltip" */ '../../stylesheets/tooltip.scss'),
    ]).then(
      ([{ default: Tooltip }]) => {
        tooltipElements.each((_index, element) => {
          Tooltip.getOrCreateInstance(element);
        });
      },
    );
  });
};

window.bootstrap = { Modal };
